import { useSelector } from "react-redux";
import { RootState } from "../store";
import { TVehicle } from "../models/inventory/interfaces/vehicle.interface";
import { ISkuVariant, TSku } from "../models/inventory/interfaces/sku.interface";

export const useSelectedVehicle = () : TVehicle => useSelector( (state: RootState) => state.applicationReducer.selectedVehicle);
export const useSelectedSku = () : TSku | null => useSelector( (state: RootState) => state.applicationReducer.selectedSku);
export const useSelectedVariant = () : ISkuVariant | null => useSelector( (state: RootState) => state.applicationReducer.selectedVariant);
export const useSelectedLoanDuration = () : number => useSelector( (state: RootState) => state.applicationReducer.selectedLoanDuration);
export const useSelectedDownPayment = () : number => useSelector( (state: RootState) => state.applicationReducer.selectedDownPayment);
export const useSelectedPartnership = () : string => useSelector( (state: RootState) => state.applicationReducer.selectedPartnership);
